// Realistic pre-populated dummy data for leads, messages, billing

export const buyerLeads = [
  { id: "ld_001", name: "Marcus Holloway", phone: "+1 (415) 555-0142", email: "marcus.h@gmail.com", budget: "$1.2M – $1.5M", score: 9, date: "2026-02-08", status: "New" },
  { id: "ld_002", name: "Priya Raghavan", phone: "+1 (212) 555-0178", email: "priya.r@outlook.com", budget: "$850K – $1.1M", score: 8, date: "2026-02-08", status: "New" },
  { id: "ld_003", name: "Daniel Cho", phone: "+1 (310) 555-0193", email: "dchoinvest@gmail.com", budget: "$2.4M – $3M", score: 10, date: "2026-02-07", status: "Contacted" },
  { id: "ld_004", name: "Sofia Mendes", phone: "+1 (305) 555-0166", email: "sofia.mendes@me.com", budget: "$650K – $800K", score: 6, date: "2026-02-07", status: "New" },
  { id: "ld_005", name: "James O'Connor", phone: "+1 (617) 555-0119", email: "joconnor@hotmail.com", budget: "$1.8M – $2.2M", score: 9, date: "2026-02-06", status: "Contacted" },
  { id: "ld_006", name: "Aaliyah Bennett", phone: "+1 (404) 555-0188", email: "aaliyahb@gmail.com", budget: "$450K – $600K", score: 5, date: "2026-02-06", status: "New" },
  { id: "ld_007", name: "Hiroshi Tanaka", phone: "+1 (206) 555-0107", email: "h.tanaka@protonmail.com", budget: "$3M+", score: 10, date: "2026-02-05", status: "New" },
  { id: "ld_008", name: "Elena Vasquez", phone: "+1 (713) 555-0132", email: "elena.v@yahoo.com", budget: "$750K – $950K", score: 7, date: "2026-02-05", status: "Contacted" },
  { id: "ld_009", name: "Brandon Pierce", phone: "+1 (702) 555-0154", email: "bpierce.re@gmail.com", budget: "$1.5M – $1.8M", score: 8, date: "2026-02-04", status: "New" },
  { id: "ld_010", name: "Naomi Sterling", phone: "+1 (646) 555-0171", email: "naomi.sterling@icloud.com", budget: "$2M – $2.5M", score: 9, date: "2026-02-04", status: "Contacted" },
  { id: "ld_011", name: "Rashid Karim", phone: "+1 (832) 555-0123", email: "r.karim@gmail.com", budget: "$520K – $680K", score: 4, date: "2026-02-03", status: "New" },
  { id: "ld_012", name: "Chloe Whitfield", phone: "+1 (415) 555-0185", email: "chloe.w@gmail.com", budget: "$900K – $1.2M", score: 7, date: "2026-02-03", status: "New" },
  { id: "ld_013", name: "Vincent Moreau", phone: "+1 (786) 555-0149", email: "vmoreau@gmail.com", budget: "$1.1M – $1.4M", score: 8, date: "2026-02-02", status: "Contacted" },
  { id: "ld_014", name: "Isabella Rossi", phone: "+1 (212) 555-0192", email: "isa.rossi@gmail.com", budget: "$1.6M – $2M", score: 9, date: "2026-02-02", status: "New" },
  { id: "ld_015", name: "Tobias Knight", phone: "+1 (303) 555-0114", email: "tobiask@outlook.com", budget: "$430K – $580K", score: 5, date: "2026-02-01", status: "New" },
];

export const sellerLeads = [
  { id: "sl_001", name: "Catherine Wells", phone: "+1 (415) 555-0211", email: "cwells@gmail.com", propertyValue: "$1.85M", score: 9, date: "2026-02-08", status: "New" },
  { id: "sl_002", name: "Robert Ashford", phone: "+1 (312) 555-0244", email: "r.ashford@me.com", propertyValue: "$3.2M", score: 10, date: "2026-02-07", status: "Contacted" },
  { id: "sl_003", name: "Margaret Liu", phone: "+1 (650) 555-0288", email: "m.liu@yahoo.com", propertyValue: "$725K", score: 6, date: "2026-02-06", status: "New" },
  { id: "sl_004", name: "Anthony DeLuca", phone: "+1 (718) 555-0202", email: "tdeluca@gmail.com", propertyValue: "$2.4M", score: 9, date: "2026-02-05", status: "New" },
  { id: "sl_005", name: "Grace Pemberton", phone: "+1 (505) 555-0277", email: "grace.p@icloud.com", propertyValue: "$1.1M", score: 8, date: "2026-02-04", status: "Contacted" },
  { id: "sl_006", name: "Omar Farouk", phone: "+1 (213) 555-0219", email: "ofarouk@gmail.com", propertyValue: "$890K", score: 7, date: "2026-02-03", status: "New" },
];

export const conversations = [
  {
    id: "cv_001", leadId: "ld_003", name: "Daniel Cho", lastTime: "2m", phone: "+1 (310) 555-0193",
    messages: [
      { from: "lead", text: "Hi, saw your ad about luxury homes in Bel Air.", time: "10:14 AM" },
      { from: "me", text: "Hey Daniel! Glad you reached out. What price range are you considering?", time: "10:15 AM" },
      { from: "lead", text: "Around $2.4M to $3M. Need 4+ bedrooms and a pool.", time: "10:17 AM" },
      { from: "me", text: "Perfect. I have 3 properties matching that criteria. Free for a quick call today?", time: "10:18 AM" },
    ],
  },
  {
    id: "cv_002", leadId: "ld_001", name: "Marcus Holloway", lastTime: "18m", phone: "+1 (415) 555-0142",
    messages: [
      { from: "lead", text: "Are the listings still available in Pacific Heights?", time: "9:42 AM" },
      { from: "me", text: "Hi Marcus, yes, two are still on the market. Want me to send the details?", time: "9:50 AM" },
    ],
  },
  {
    id: "cv_003", leadId: "ld_007", name: "Hiroshi Tanaka", lastTime: "1h", phone: "+1 (206) 555-0107",
    messages: [
      { from: "lead", text: "Looking for waterfront, 4+ beds, modern build.", time: "8:22 AM" },
      { from: "me", text: "I have a stunning new build on Lake Washington. Sending you the listing now.", time: "8:31 AM" },
      { from: "lead", text: "Thanks. What's the asking?", time: "8:35 AM" },
    ],
  },
  {
    id: "cv_004", leadId: "ld_010", name: "Naomi Sterling", lastTime: "3h", phone: "+1 (646) 555-0171",
    messages: [
      { from: "lead", text: "Can we tour the Brooklyn brownstone this weekend?", time: "Yesterday" },
      { from: "me", text: "Absolutely. Saturday 11 AM works. I'll send confirmation.", time: "Yesterday" },
    ],
  },
  {
    id: "cv_005", leadId: "ld_005", name: "James O'Connor", lastTime: "1d", phone: "+1 (617) 555-0119",
    messages: [
      { from: "lead", text: "Beacon Hill historic homes, what's available?", time: "Mon" },
      { from: "me", text: "Two on the market. Let me email the listings.", time: "Mon" },
    ],
  },
  {
    id: "cv_006", leadId: "ld_014", name: "Isabella Rossi", lastTime: "2d", phone: "+1 (212) 555-0192",
    messages: [
      { from: "lead", text: "Interested in Tribeca lofts under $2M.", time: "Sun" },
      { from: "me", text: "I have 4 great options. Want me to schedule viewings this week?", time: "Sun" },
    ],
  },
];

export const billingHistory = [
  { date: "Feb 1, 2026", amount: "$399.00", status: "Paid", plan: "Pro" },
  { date: "Jan 1, 2026", amount: "$399.00", status: "Paid", plan: "Pro" },
  { date: "Dec 1, 2025", amount: "$399.00", status: "Paid", plan: "Pro" },
  { date: "Nov 1, 2025", amount: "$399.00", status: "Paid", plan: "Pro" },
];

// Sample campaigns shown to FREE-tier users so they can see what a launched
// Lead Engine workspace looks like (with realistic budgets + real creative
// previews). Free users don't actually save these — the LeadGenerator page
// hydrates from this object when `usePaywall().locked` is true.
// Each creative is just a stock image URL (Unsplash, CORS-enabled) — slotted
// straight into the same <img src={...}/> render path that real uploads use.
export const sampleCampaigns = {
  buyer: {
    daily: 75,
    launched: true,
    launchedAt: "2026-02-04T09:12:00Z",
    creatives: [
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=900&h=1125&fit=crop&auto=format&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&h=1125&fit=crop&auto=format&q=80",
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=900&h=1125&fit=crop&auto=format&q=80",
    ],
  },
  seller: {
    daily: 100,
    launched: false,
    launchedAt: null,
    creatives: [
      "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=900&h=1125&fit=crop&auto=format&q=80",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=900&h=1125&fit=crop&auto=format&q=80",
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=900&h=1125&fit=crop&auto=format&q=80",
    ],
  },
};

export const scoreColor = (score) => {
  if (score >= 7) return {
    text: "text-emerald-400", bg: "bg-emerald-500/10", border: "border-emerald-500/30",
    textLight: "text-emerald-700", bgLight: "bg-emerald-50", borderLight: "border-emerald-200",
    label: "High",
  };
  if (score >= 4) return {
    text: "text-amber-400", bg: "bg-amber-500/10", border: "border-amber-500/30",
    textLight: "text-amber-700", bgLight: "bg-amber-50", borderLight: "border-amber-200",
    label: "Med",
  };
  return {
    text: "text-red-400", bg: "bg-red-500/10", border: "border-red-500/30",
    textLight: "text-red-700", bgLight: "bg-red-50", borderLight: "border-red-200",
    label: "Low",
  };
};
